import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const greet = () => { const h = new Date().getHours(); return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening"; };
const Stat = ({ l, v }) => (
  <div className="border border-foreground/20 p-4"><p className="font-serif text-3xl">{v}</p><p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-1">{l}</p></div>
);

export default function AdminDashboardHome({ onGo }) {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <p className="font-mono text-sm text-muted-foreground">Loading…</p>;

  const a = d.actions, t = d.today, q = d.quality;
  const items = [
    { n: a.products_pending, l: "Products awaiting approval" },
    { n: a.change_requests, l: "Product changes" },
    { n: a.vendor_applications, l: "Vendor applications" },
    { n: a.inspections, l: "Inspections" },
    { n: a.returns, l: "Returns requiring review" },
  ];
  const total = items.reduce((s, i) => s + (i.n || 0), 0);

  return (
    <div className="space-y-12">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))]">Inspection Floor</p>
        <h2 className="font-serif text-5xl tracking-tighter mt-1">{greet()}, {(user?.name || "").split(" ")[0] || "Spotter"}.</h2>
        <p className="text-muted-foreground mt-2">Marketplace operations at a glance.</p>
      </div>

      <div className="border-2 border-foreground p-6">
        <div className="flex items-center justify-between mb-5 gap-4 flex-wrap">
          <p className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))]">Action required · {total}</p>
          <button onClick={() => onGo("action_center")} className="bg-foreground text-background px-4 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-[hsl(var(--accent))]">Review actions →</button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {items.map((i) => (
            <button key={i.l} onClick={() => onGo("action_center")} className="text-left border border-foreground/20 p-4 hover:border-foreground transition-colors">
              <p className={`font-serif text-4xl ${i.n ? "text-[hsl(var(--accent))]" : "text-muted-foreground"}`}>{String(i.n || 0).padStart(2, "0")}</p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-1 leading-tight">{i.l}</p>
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))] mb-3">Marketplace today</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat l="Orders" v={t.orders} />
          <Stat l="GMV" v={`₹${Number(t.gmv).toLocaleString("en-IN")}`} />
          <Stat l="New customers" v={t.new_customers} />
          <Stat l="New vendors" v={t.new_vendors} />
        </div>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))] mb-3">Quality</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat l="Inspection pass rate" v={q.inspection_pass_rate != null ? `${q.inspection_pass_rate}%` : "—"} />
          <Stat l="Return rate" v={`${q.return_rate}%`} />
          <Stat l="Avg rating" v={q.avg_rating != null ? q.avg_rating : "—"} />
          <Stat l="Live products" v={q.live_products} />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))] mb-3">Top vendors</p>
          {d.vendors.top.length ? (
            <div>{d.vendors.top.map((v) => <div key={v.slug} className="flex justify-between border-b border-foreground/15 py-2"><span className="font-serif">{v.store_name}</span><span className="font-mono text-xs">{v.total_sales || 0} sales</span></div>)}</div>
          ) : <p className="text-sm text-muted-foreground">No sales data yet.</p>}
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-destructive mb-3">Needs attention</p>
          {d.vendors.attention.length ? (
            <div>{d.vendors.attention.map((v) => <div key={v.slug} className="flex justify-between border-b border-foreground/15 py-2"><span className="font-serif">{v.store_name}</span><span className="font-mono text-xs text-destructive">{Math.round((v.failure_rate || 0) * 100)}% failure</span></div>)}</div>
          ) : <p className="text-sm text-muted-foreground">All vendors healthy.</p>}
        </div>
      </div>
    </div>
  );
}
